import { useTranslation } from 'react-i18next';
import type { RemovalTier } from '@wrapforce/shared';
import { Input, Label } from '@/components/ui/input';

const REMOVAL_TIERS: RemovalTier[] = ['none', 'light', 'moderate', 'heavy_baked'];

export function ConditionChecklist({
  removalTier, onChangeRemovalTier, defectPanelCount, onChangeDefectPanelCount,
  correctionFeeCents, onChangeCorrectionFeeCents,
}: {
  removalTier: RemovalTier;
  onChangeRemovalTier: (tier: RemovalTier) => void;
  defectPanelCount: number;
  onChangeDefectPanelCount: (n: number) => void;
  correctionFeeCents: number;
  onChangeCorrectionFeeCents: (cents: number) => void;
}) {
  const { t } = useTranslation('quotes');
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <Label htmlFor="removal-tier">{t('pricing.condition.removalLabel')}</Label>
        <select
          id="removal-tier"
          value={removalTier}
          onChange={(e) => onChangeRemovalTier(e.target.value as RemovalTier)}
          className="h-9 border border-border bg-surface px-2 text-sm"
        >
          {REMOVAL_TIERS.map((tier) => (
            <option key={tier} value={tier}>{t(`pricing.removalTier.${tier}`)}</option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-2 gap-2.5">
        <div className="flex flex-col justify-between gap-1">
          <Label htmlFor="defect-panels">{t('pricing.condition.defectPanelsLabel')}</Label>
          <Input
            id="defect-panels"
            type="number"
            min={0}
            value={defectPanelCount}
            onChange={(e) => onChangeDefectPanelCount(Math.max(0, Number(e.target.value)))}
          />
        </div>
        <div className="flex flex-col justify-between gap-1">
          <Label htmlFor="correction-fee">{t('pricing.condition.correctionFeeLabel')}</Label>
          <Input
            id="correction-fee"
            type="number"
            min={0}
            step={0.01}
            value={correctionFeeCents / 100}
            onChange={(e) => onChangeCorrectionFeeCents(Math.max(0, Math.round(Number(e.target.value) * 100)))}
          />
        </div>
      </div>

      <p className="text-xs text-muted">
        {t('pricing.condition.photoNote')}
      </p>
    </div>
  );
}
